<ng-template
  [cxOutlet]="cartOutlets.ORDER_SUMMARY"
  [cxOutletContext]="cart$ | async"
>
</ng-template>
